// SnowPackParametersForm.jsx
import { useState } from "react"
import { Grid } from '@mui/material'
import "../../css/DemoCode.css"

/**
 * Options Dynamic Wave Form is a group of data inputs usually shown when clicking on Options->Dynamic Wave. 
 * 
 * @param {JSON} model A SWMM model in JSON format. In most cases this
 * is a 'submodel' containing only a copy of the affected sections. Using a copy allows
 * for continuous react-style editing without forcing the model to run on every keystroke.
 * @param {function} setModel Update function for updating 'model'.
 * @param {string} target The name of the object targetted by this form.
 * @returns UI for interactive swmm modeling.
 */
export default function SnowPackParametersForm({model, setModel, target}) {
  const objsIndexes = useState([0, 1, 2, 3, 4, 5, 6])

  // When there is a change to an input element, modify the model.
  const updateValue = (val, type, varName) => {
    // Don't let any undefined updates go through.
    if(val === undefined) val = ''
    if(model && model.SNOWPACKS && model.SNOWPACKS[target] && model.SNOWPACKS[target][type]){
      setModel(prev => ({
        ...prev,
        SNOWPACKS:{
          ...prev.SNOWPACKS,
          [target]: {
            ...prev.SNOWPACKS[target],
            [type]: {
              ...prev.SNOWPACKS[target][type],
              [varName]: val
            }
          }
        }
      }))
    }
  }

  // Descriptive text and names of parameters
  const UIParams = [
    {name: 'Cmin', uiText: 'Min. Melt Coeff'},
    {name: 'Cmax', uiText: 'Max. Melt Coeff'},
    {name: 'Tbase', uiText: 'Base Temp'},
    {name: 'FWF',  uiText: 'Free Water Capacity'},
    {name: 'SD0',  uiText: 'Init. Snow Depth'},
    {name: 'FW0', uiText: 'Init. Free Water'},
    {name: 'SD100', uiText: 'Depth at 100% Cover'}
  ]

  return(
    <>
    {
      model.SNOWPACKS &&
      model.SNOWPACKS[target] &&
      <>
      <Grid container style={{fontSize: '12px'}}>
        <Grid item xs={6} style={{fontSize: '12px'}}>
          <div style={{borderBottom:'3px solid #fff'}}>Surface Type</div>
        </Grid>
        <Grid item xs={2}>
          <div style={{borderBottom:'3px solid #fff'}}>Plowable</div>
        </Grid>
        <Grid item xs={2}>
          <div style={{borderBottom:'3px solid #fff'}}>Imperv.</div>
        </Grid>
        <Grid item xs={2}>
          <div style={{borderBottom:'3px solid #fff'}}>Pervious</div>
        </Grid>
        {
          objsIndexes.map(v=>{
              return (
                <Grid container key={'snowpackparameters'+v}>
                  <Grid item xs={6} style={{fontSize: '12px'}}>
                    {
                      <label  style={{height: '22px'}}
                              className='editor-small'
                              key={'LID_CONTROLS_uiText'+UIParams[v].name.toString()}
                      >{UIParams[v].uiText}</label>
                    }
                  </Grid>
                  <Grid item xs={2}>
                    {
                      <input  type = "number"
                        style={{width: '95%', display: 'flex'}}
                        onChange={(e)=>{updateValue(e.target.value, 'PLOWABLE', UIParams[v].name)}}
                        value={model.SNOWPACKS[target].PLOWABLE[UIParams[v].name]}
                        id={'ClimatologyADCPer'+v.toString()}
                        key={'ClimatologyADCImp'+v.toString()}
                      />
                    }
                  </Grid>
                  <Grid item xs={2}>
                    {
                      <input  type = "number"
                        style={{width: '95%', display: 'flex'}}
                        onChange={(e)=>{updateValue(e.target.value, 'IMPERVIOUS', UIParams[v].name)}}
                        value={model.SNOWPACKS[target].IMPERVIOUS[UIParams[v].name]}
                        id={'ClimatologyADCImp'+v.toString()}
                        key={'ClimatologyADCImp'+v.toString()}
                      />
                    }
                  </Grid>
                  <Grid item xs={2}>
                    {
                      <input  type = "number"
                        style={{width: '95%', display: 'flex'}}
                        onChange={(e)=>{updateValue(e.target.value, 'PERVIOUS', UIParams[v].name)}}
                        value={model.SNOWPACKS[target].PERVIOUS[UIParams[v].name]}
                        id={'ClimatologyADCPer'+v.toString()}
                        key={'ClimatologyADCImp'+v.toString()}
                      />
                    }
                  </Grid>
                </Grid>
              )
            })
          }
      </Grid>
      </>
    }
    </>
  )
}